import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const RequestRoute: Route = {
  path: 'request',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/request.component').then((m) => m.RequestComponent),
    },
    {
      path: ':requestId',
      loadComponent: () => import('./pages/details/request-details.component').then((m) => m.RequestDetailsComponent),
    },
    {
      path: ':requestId/activity/:activityId',
      loadComponent: () => import('./pages/details/activity-details.component').then((m) => m.ActivityDetailsComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
